import {Storage} from "@/services/Storage";
import axios from "axios";

export default {
    name: 'tax',

    state: {
        hasDocsSubmitted: false,
        isSmartInvoiceLive: true,
        taxLabels : [],
    },
    getters: {
        getDocSubmissionStatus: (state) => state.hasDocsSubmitted,
        getSmartInvoicingLive: (state) => state.isSmartInvoiceLive,
        getTaxLabels : (state) => state.taxLabels,
        getZraCategoryByLabel : (state) => (taxLabel) => {
            return state.taxLabels.find(category => category.TaxLabel.toLowerCase() === taxLabel.toLowerCase());
        }
    },
    mutations: {
        setDocSubmissionStatus: (state, data) => state.hasDocsSubmitted = data,
        setTaxLabels : async (state , payload) => {
            if (!payload) payload = await Storage.getAllTaxLabels();
            state.taxLabels = payload;
        }
    },
    actions: {
        checkIfStoreDocsSubmitted: async (context) => {
            let DB = await Storage.getCurrentStoreDB();
            DB = window.btoa(DB);
            return axios.get(ticketApi + `smartInvoiceOnboard/checkDocumentSubmissionStatus`, {
                headers: {DB}
            }).then(({data}) => context.commit(`setDocSubmissionStatus`, data))

        },
        getAllTaxLabels : async (context) => {
            let store = await Storage.getDefaultStore();
            if (!store) return ;
            return axios.get(backOfficeTomcatApi+`zra_category/${store.StoreDB}/getAll`)
                .then(({data}) => context.commit(`setTaxLabels`, data))
                .catch(err=>errorHandler.tomcatError(err))
        },
    }
}
